import { AxiosPromise, AxiosResponse } from 'axios';

import AppStorage from '../../Storage/Storage';
import Requests from '../Requests';
import { HealthDocFileUploaded } from '../../interfaces/HealthDocFile';
import { createUploadHealthDocsPostData } from '../../utils/utils';
import HealthDeclarationUploadedDocuments from '../../interfaces/HealthDeclarationUploadedDocuments';

export default class DocumentsService {
  private readonly storage: AppStorage;

  constructor() {
    this.storage = AppStorage.getInstance();
  }

  getUploadedDocuments = (): Promise<HealthDocFileUploaded[]> => (
    Requests.getUploadedDocuments()
      .then((response: AxiosResponse<HealthDeclarationUploadedDocuments>) => response.data.result)
      .catch((err) => {
        throw err;
      })
  );

  uploadDocuments = (): AxiosPromise => {
    const files = this.storage.getHealthDeclarationFileList;
    const newFiles = files.filter((file) => !file.isLoaded);
    const postData = createUploadHealthDocsPostData(newFiles);
    return Requests.uploadDocuments(postData);
  };
}
